// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class JsonldService {
   contributors: any
   id: any
   isbns: any
   issns: any
   result: any
   results: any
   type: any
   utilitiesService: any
   constructor(utilitiesService: any) {
      this.mapDocumentToJsonld = this.mapDocumentToJsonld.bind(this)
      this.mapCommonProperties = this.mapCommonProperties.bind(this)
      this.mapSpecificProperties = this.mapSpecificProperties.bind(this)
      this.tryMapPropertyValue = this.tryMapPropertyValue.bind(this)
      this.mapIdentifier = this.mapIdentifier.bind(this)
      this.isArticleRelatedType = this.isArticleRelatedType.bind(this)
      this.mapIsPartOf = this.mapIsPartOf.bind(this)
      this.mapAbout = this.mapAbout.bind(this)
      this.mapPublisher = this.mapPublisher.bind(this)
      this.mapSameAs = this.mapSameAs.bind(this)
      this.mapIssn = this.mapIssn.bind(this)
      this.mapIsbn = this.mapIsbn.bind(this)
      this.mapCreators = this.mapCreators.bind(this)
      this.mapContributors = this.mapContributors.bind(this)
      this.mapOrganization = this.mapOrganization.bind(this)
      this.mapPerson = this.mapPerson.bind(this)
      this.mapType = this.mapType.bind(this)
      this.mapId = this.mapId.bind(this)
      this.utilitiesService = utilitiesService
   }

   mapDocumentToJsonld(doc: any) {
      return angular.extend({}, this.mapCommonProperties(doc), this.mapSpecificProperties(doc))
   }

   mapCommonProperties(doc: any) {
      return {
         "@context": "http://schema.org",
         "@type": this.mapType(doc),
         "@id": this.mapId(doc),
         creator: this.mapCreators(doc),
         contributor: this.mapContributors(doc),
         description: doc.abstracts?.[0]?.abstract,
         workExample: doc.editions?.[0],
         issn: this.mapIssn(doc),
         isbn: this.mapIsbn(doc),
         sameAs: this.mapSameAs(doc),
         publisher: this.mapPublisher(doc),
         datePublished: doc.publication_date,
         about: this.mapAbout(doc),
         identifier: this.mapIdentifier(doc),
         // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
         lccallnum: this.tryMapPropertyValue(doc.lc_call_numbers, "lccallnum")
      }
   }
   // TODO: Get feedback on how to map these properties
   // "inLanguage": @mapInLanguage(doc),
   // "url": 

   mapSpecificProperties(doc: any) {
      if (this.isArticleRelatedType(doc)) {
         return {isPartOf: this.mapIsPartOf(doc)}
      } else {
         return {name: this.utilitiesService.removeHithighlightTags(doc.title)}
      }
   }

   tryMapPropertyValue(source: any, propertyId: any, sameAsPrefix: any) {
      if (source) {
         return source.map((item: any) => {
            this.result = {
               "@type": "PropertyValue",
               propertyID: propertyId,
               value: item
            }

            if (sameAsPrefix) { this.result.sameAs = `${sameAsPrefix}${this.result.value}` }

            return this.result
         })
      }
   }

   mapIdentifier(doc: any) {
      this.results = []
    
      this.id = this.tryMapPropertyValue(doc.oclcs, "oclc", "http://www.worldcat.org/oclc/")
      if (this.id) { this.results = this.results.concat(this.id) }

      this.id = this.tryMapPropertyValue(doc.pmids, "pmid", "https://www.ncbi.nlm.nih.gov/pubmed/")
      if (this.id) { this.results = this.results.concat(this.id) }
    
      this.id = this.tryMapPropertyValue(doc.lccns, "lccn", "https://lccn.loc.gov/")
      if (this.id) { this.results = this.results.concat(this.id) }

      return this.results
   }

   isArticleRelatedType(doc: any) {
      this.type = this.mapType(doc)
      return (this.type === "Article") || (this.type === "NewsArticle") || (this.type === "ScholarlyArticle") || (this.type === "Chapter")
   }

   mapIsPartOf(doc: any) {
      return {
         "@id": "_id",
         name: this.utilitiesService.removeHithighlightTags(doc.title),
         pageStart: doc.startPages?.[0],
         pageEnd: doc.endPages?.[0],
         pagination: doc.pages
      }
   }

   mapAbout(doc: any) {
      if (doc.subject_terms) {
         return doc.subject_terms.map((term: any) => { 
            return {
               "@type": "Thing",
               name: term
            }
         })
      }
   }

   mapPublisher(doc: any) {
      if (doc.publisher) {
         return {
            "@type": "Organization",
            name: doc.publisher
         }
      }
   }

   mapSameAs(doc: any) {
      if (doc.dois) {
         return doc.dois.map((doi: any) => `http://dx.doi.org/${doi}`)
      }
   }

   mapIssn(doc: any) {
      if (doc.issns) { this.issns = doc.issns }
      if (doc.eissns) { this.issns = this.issns.concat(doc.eissns) }
      return this.issns
   }

   mapIsbn(doc: any) {
      if (doc.isbns) { this.isbns = doc.isbns }
      if (doc.eisbns) { this.isbns = this.isbns.concat(doc.eisbns) }
      return this.isbns
   }

   mapCreators(doc: any) {
      if (doc.authors?.length) { return this.mapPerson(doc.authors[0]) }
   }

   mapContributors(doc: any) {
      this.contributors = []

      if (doc.authors && (doc.authors.length > 1)) {
         this.contributors = doc.authors.slice(1).map((author: any) => {
            return this.mapOrganization(author)
         })
      }

      if (doc.corporate_authors) {
         this.contributors = this.contributors.concat(doc.corporate_authors.map((corporate: any) => {
            return this.mapOrganization(corporate)
         }))
      }

      return this.contributors
   }

   mapOrganization(organization: any) {
      return {
         "@type": "Organization",
         name: organization.fullname
      }
   }

   mapPerson(person: any) {
      return {
         "@type": "Person",
         name: person.fullname
      }
   }

   mapType(doc: any) {
      switch (doc.content_type) {
         case "Book Chapter": return "Chapter"
         case "Journal Article": case "Magazine Article":
            if (doc.is_peer_reviewed) {
               return "ScholarlyArticle"
            } else {
               return "Article"
            }
         case "Photograph": return "Photograph"
         case "Journal": case "eJournal": case "Magazine": case "Newspaper": return "Periodical"
         case "Book": case "eBook": return "Book"
         case "Map": return "Map"
         case "Data Set": return "Dataset"
         case "Book Review": case "Magazine Article": case "Newspaper Article": return "Article"
         case "Music Manuscript": case "Music Score": return "MusicComposition"
         case "Report": return "Report"
         case "Film": case "Video Recording": case "DVD": return "Movie"
         case "Web Resource": return "WebSite"
         case "Dissertation": case "Student Thesis": return "Thesis"
         case "Drawing": return "Drawing"
         case "Manuscript": return "Manuscript"
         case "Painting": return "Painting"
         case "Poster": return "Poster"
         case "Play": return "Play"
         default: return "CreativeWork"
      }
   }

   mapId(doc: any) {
      return `/document?id=${doc.id}`
   }
}

JsonldService.$inject = ['utilitiesService']

angular.module('summonApp.services')
   .service('jsonldService', JsonldService)
